const COUNTRY_LABELS: Record<string, string> = {
  RU: "俄罗斯",
  CN: "中国",
  US: "美国",
  KZ: "哈萨克斯坦",
  BY: "白俄罗斯",
  UA: "乌克兰",
  TR: "土耳其",
  BR: "巴西",
  IN: "印度",
  ID: "印度尼西亚",
};

export function countryLabel(code: string): string {
  const key = (code || "").trim().toUpperCase();
  if (!key) return "—";
  return COUNTRY_LABELS[key] || code;
}
